<!--Header End-->
<router-outlet></router-outlet>

<!-- <div class="whatsapp_chat_support wcs_fixed_right wcs-show" id="example_1" *ngIf="whatsapp_bool">
  <div class="wcs_button_label">
    Post Your Exam Related queries
  </div>
  <div class="wcs_button wcs_button_circle">
    <span class="fa fa-whatsapp"></span>
  </div>

  <div class="wcs_popup">
    <div class="wcs_popup_close">
      <span class="fa fa-close" (click)="show_need()">
      </span>
    </div>
    <div class="wcs_popup_header">
      <strong style="color: #fff;">Need Help? </strong>
      <br>
      <div class="wcs_popup_header_description">Click one of our Help Desk representatives below | Chat with us from 10
        AM to 6 PM</div>
    </div>
    <div class="wcs_popup_person_container">

     <div class="wcs_popup_person" data-number="528123861273">
        <div class="wcs_popup_person_img"><img src="assets/images/sanjay.png" alt=""></div>
        <div class="wcs_popup_person_content">
          <div class="wcs_popup_person_name">Sanjay Kumar</div>
          <div class="wcs_popup_person_description">Help Desk 1</div>
          <button [disabled]='disabled_bool' class="wcs_popup_person_status {{time_clr}}"
            (click)="tested3()">{{var_online}}</button>
        </div>
      </div>

      <div class="wcs_popup_person" aria-disabled="true">
        <div class="wcs_popup_person_img"><img src="assets/images/veera.png" alt=""></div>
        <div class="wcs_popup_person_content">
          <div class="wcs_popup_person_name">Veera Kumar </div>
          <div class="wcs_popup_person_description">Help Desk 2</div>
          <button [disabled]='disabled_bool' class="wcs_popup_person_status {{time_clr}}"
            (click)="tested()">{{var_online}}</button>
        </div>
      </div>

      <div class="wcs_popup_person" data-number="528123861273">
        <div class="wcs_popup_person_img"><img src="assets/images/nirmal.png" alt=""></div>
        <div class="wcs_popup_person_content">
          <div class="wcs_popup_person_name">Nirmal Kumar</div>
          <div class="wcs_popup_person_description">Help Desk 3</div>
          <button [disabled]='disabled_bool' class="wcs_popup_person_status {{time_clr}}"
            (click)="tested2()">{{var_online}}</button>
        </div>
      </div>


    </div>
  </div>
</div>

<div (click)="show_main()" class="whatsapp_chat_support wcs_fixed_right" id="example_2" *ngIf="need_bool">
  <div class="wcs_button">

    <span class="fa fa-whatsapp"> </span>
    NIMI Help Desk
  </div>
</div> -->
